import { BUNDLE_ORDER_TYPE, FLAG } from '@shared/payments-types';

import type { PaymentOrders } from './PaymentOrders';

export const base: PaymentOrders = {
    stateDetailI18nPrefix: 'transaction.status',
    stateDetailDescriptionI18nPrefix: 'transaction.statusLong',
    collectiveSigningAllowedCurrencies: [],
    shouldShowUserIdInAuthorizations: false,
    shouldShowOwnTransferAsDomesticIcon: false,
    shouldShowPurposeCodeOrderValue: false,
    showTransactionIdInSigning: false,
    collectiveSigningFlag: FLAG.COLLECTIVE_SIGNING,
    shouldDisplayDonationsTaxReductionMessage: false,
    orderActions: {
        isPrintEnabled: true,
    },
    orderBundler: {
        config: {
            DEFAULT: [
                {
                    combination: [BUNDLE_ORDER_TYPE.OWN_FX],
                    maxSize: 1,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: false,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
                {
                    combination: [BUNDLE_ORDER_TYPE.DOMESTIC],
                    maxSize: 5,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: true,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
                {
                    combination: [BUNDLE_ORDER_TYPE.SEPA],
                    maxSize: 3,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: true,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
                {
                    combination: [BUNDLE_ORDER_TYPE.INTERNATIONAL],
                    maxSize: 3,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: true,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
            ],
        },
    },
    hasLegalEntityRestrictionForBundleSigning: false,
    showApplicationId: false,
    showChannelId: false,
    showId: false,
    showLastModification: false,
    alwaysRedo: true,
    failedOrderStates: [
        'AGB',
        'BAM',
        'BAN',
        'BPA',
        'BPR',
        'CBA',
        'EEI',
        'FRD',
        'IPA',
        'IPC',
        'IPE',
        'ISA',
        'KAG',
        'NGA',
        'OBG',
        'REC',
    ],
    waitingOrderStates: ['AFU', 'AFP', 'SUS', 'INB', 'COS', 'WEA', 'WEU', 'WEP', 'PSI'],
    cancelledInDoneOrderStates: ['REC'],
    dataCarrier: {
        pollingInterval: 10_000,
        useStateDetailForBadge: false,
    },
    verificationOfPayee: {
        showSigningDescriptionForMatch: true,
    },
    requestDoubleSigningInCaseOfPossibleFraud: false,
    shouldShowFraudAndScamPatternsLink: true,
    shouldDisplayTacInfo: true,
};
